import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBt8266PWEWiA73bfNFLoK47eydx9xWLmo",
  authDomain: "etype-final.firebaseapp.com",
  projectId: "etype-final",
  storageBucket: "etype-final.firebasestorage.app",
  messagingSenderId: "259618392070",
  appId: "1:259618392070:web:3f97ae11a01b85ef40db87",
  measurementId: "G-W00N99DK54"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// In local development, generate an App Check debug token (printed to the browser console).
// Register it under App Check > Apps > Manage debug tokens. Never active in production builds.
if (process.env.NODE_ENV === 'development') {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

// App Check - verifies requests come from this app (reCAPTCHA v3). Site key is public.
export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LeSrTAtAAAAACoSG9zA79qijr6MpjCGwnG7Vcds'),
  isTokenAutoRefreshEnabled: true,
});

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
